import React from 'react';
import { ArrowRight } from 'lucide-react';

// Option A: Split Hero - Modern SaaS Style
const OptionA = () => {
  const scrollToPricing = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Split Hero Section */}
      <section style={{ display: 'flex', minHeight: '100vh', flexWrap: 'wrap' }}>
        {/* Left Side - Content */}
        <div
          style={{
            flex: '1 1 50%',
            minWidth: '500px',
            background: 'linear-gradient(135deg, #FFE5D0 0%, #FFDDB8 50%, #FFD4A8 100%)',
            display: 'flex',
            alignItems: 'center',
            padding: '80px 60px',
          }}
        >
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div
              style={{
                fontSize: 'clamp(0.9rem, 1vw, 1rem)',
                fontWeight: '600',
                color: '#C84B31',
                textTransform: 'uppercase',
                letterSpacing: '0.15em',
                marginBottom: '24px',
              }}
            >
              For Malaysian Parents
            </div>
            
            <h1
              style={{
                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                fontWeight: '900',
                lineHeight: '1.1',
                color: '#2C2823',
                marginBottom: '32px',
                fontFamily: "'PP Right Grotesk', 'Inter', Arial, sans-serif",
              }}
            >
              CONFIDENT SCHOOL DECISIONS, BUILT AROUND YOUR CHILD.
            </h1>

            <p
              style={{
                fontSize: '1.35rem',
                lineHeight: '1.6',
                color: '#6B6560',
                marginBottom: '40px',
              }}
            >
              A 15-minute diagnostic that cuts through the noise — fee projections, tuition data, and honest school comparisons, all in one report.
            </p>

            <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={scrollToPricing}
                style={{
                  background: '#E85D35',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10rem',
                  padding: '1.2em 2.5em',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                }}
                onMouseOver={(e) => (e.target.style.transform = 'scale(1.02)')}
                onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
              >
                See How It Works (RM4.99)
                <ArrowRight size={20} />
              </button>
            </div>

            <div style={{ marginTop: '48px', display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontSize: '2rem', fontWeight: '900', color: '#E85D35' }}>500+</div>
                <div style={{ fontSize: '0.85rem', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                  Parents Served
                </div>
              </div>
              <div>
                <div style={{ fontSize: '2rem', fontWeight: '900', color: '#E85D35' }}>45+</div>
                <div style={{ fontSize: '0.85rem', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                  Schools Covered
                </div>
              </div>
              <div>
                <div style={{ fontSize: '2rem', fontWeight: '900', color: '#E85D35' }}>94%</div>
                <div style={{ fontSize: '0.85rem', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                  Satisfaction
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Image */}
        <div
          style={{
            flex: '1 1 50%',
            minWidth: '500px',
            minHeight: '600px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_clean-typography-1/artifacts/sr5hx03f_pexels-alex-green-5691834.jpg"
            alt="Happy children"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center 30%',
            }}
          />
        </div>
      </section>

      {/* Quick Preview Section */}
      <section style={{ padding: '80px 40px', textAlign: 'center', background: 'var(--bg-card)' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '900', color: '#2C2823', marginBottom: '16px' }}>
          OPTION A: SPLIT HERO LAYOUT
        </h2>
        <p style={{ fontSize: '1.1rem', color: '#6B6560', maxWidth: '600px', margin: '0 auto' }}>
          Modern SaaS style with 50/50 split. Maximum readability, professional, clean.
        </p>
      </section>
    </div>
  );
};

export default OptionA;
